import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AICommand } from './base.commands';
import { AICommandPayload } from './command-payload.model';

@Injectable({ providedIn: 'root' })
export class BaseCommandHandler<T extends AICommand<any>> {
  handle(command: T): Observable<AICommandPayload<T>> {
    return of({
      command,
    });
  }
}
